import { lazy } from 'react';

// Set while we've just reloaded because a page chunk failed to load.
const RELOAD_MARKER = 'lazy-page-reloaded';

/**
 * Load a code-split page module. Chunk filenames change on every deploy, so a
 * tab still running the previous build can ask for a chunk that no longer
 * exists. In that case reload once to pick up the new build; if loading still
 * fails after that reload, rethrow so the real error shows instead of looping.
 * @param {() => Promise<object>} importPage - e.g. () => import('../pages/Requests')
 * @param {() => void} [reload] - injectable for tests
 */
export async function loadPageModule(importPage, reload = () => window.location.reload()) {
  try {
    const module = await importPage();
    sessionStorage.removeItem(RELOAD_MARKER);
    return module;
  } catch (error) {
    if (sessionStorage.getItem(RELOAD_MARKER)) throw error;
    sessionStorage.setItem(RELOAD_MARKER, '1');
    reload();
    return new Promise(() => {}); // the page is reloading; never settle
  }
}

/** React.lazy for a page, with the reload-once recovery above. */
export const lazyPage = (importPage) => lazy(() => loadPageModule(importPage));
